import '@cabgo/ui/styles.css';
import './styles/app.css';
import './i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { BuildBadge } from './components/BuildBadge';
import { AuthProvider } from './lib/auth';
import { configureQueryFocusEvents } from './lib/presencePolling';
import { initSentry, Sentry } from './lib/sentry';

// Crash reporting first so even render/boot failures report (no-op sans DSN).
initSentry();
configureQueryFocusEvents();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 15_000 } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Render-crash capture + a recoverable fallback instead of a white page. */}
    <Sentry.ErrorBoundary
      fallback={
        <div className="cg-center" style={{ minHeight: '100vh', flexDirection: 'column', gap: 12 }}>
          <p>เกิดข้อผิดพลาด กรุณาโหลดหน้าใหม่ / Something went wrong — please reload.</p>
          <button type="button" className="cg-btn cg-btn--primary" onClick={() => window.location.reload()}>
            โหลดใหม่
          </button>
        </div>
      }
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider onSessionCleared={() => queryClient.clear()}>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
    <BuildBadge />
  </StrictMode>,
);
